
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component({
  name: "KunMingNavigation",
  components: {},
})
export default class KunMingNavigation extends Vue {
  navTabs = [
    {
      label: "首页",
      children: [
        "/kunming/home",
        // '/pcm/company',
        // '/pcm/allpolicy',
        "/kunmingdetail/match",
        "/kunmingdetail/allpolicy",
        "/kunmingdetail/apply",
        "/kunmingdetail/company",
        // '/pcm/company/detail',
        // '/pcm/keyword/detail',
      ],
      default: "/kunming/home",
      index: 0,
    },
    {
      label: "政策库",
      children: [
        "/kunming/policy",
        // '/pcm/company',
        // '/pcm/allpolicy',
        "/kunmingdetail/policy",
        // '/pcm/company/detail',
        // '/pcm/keyword/detail',
      ],
      default: "/kunming/policy",
      index: 1,
    },
    {
      label: "无申请兑现",
      children: [
        "/kunming/apply",
        // '/pcm/keyword/detail',
      ],
      default: "/kunming/apply",
      index: 2,
    },
    // {
    //   label: '政策清单',
    //   children: ["/pcm/list"],
    //   default: '/pcm/list',
    //   index: 7,
    // },
  ];
  activeName = "";
  handleClick(e: any) {
    const activeName = Number(e.$el.id.replace("pane-page", ""));
    const currenName = this.$route.name;
    this.$router.push({ path: this.navTabs[activeName].default });
  }
  created() {
    this.fixTab();
  }
  fixTab() {
    const currentRouter = this.$route.path;
    const currentActive = this.navTabs.find((item: any) =>
      item.children.includes(currentRouter)
    );
    this.activeName = `page${currentActive?.index}`;
  }
  @Watch(`$route`)
  routechange(to: any, from: any) {
    this.fixTab();
  }
}
